import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

const UPDATE_CHECK_INTERVAL = 30 * 1000 // 30 seconds

export default function UpdatePrompt() {
  useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return
      registration.update()
      setInterval(() => registration.update(), UPDATE_CHECK_INTERVAL)
    },
  })

  useEffect(() => {
    if (!navigator.serviceWorker) return
    // Track whether a SW was already controlling the page at mount time.
    // If yes and the controller changes, a new SW just took over — reload so
    // the page runs the new JS bundle instead of the stale one.
    const hadController = !!navigator.serviceWorker.controller
    let reloading = false
    const handler = () => {
      if (!hadController || reloading) return
      reloading = true
      window.location.reload()
    }
    navigator.serviceWorker.addEventListener('controllerchange', handler)
    return () => navigator.serviceWorker.removeEventListener('controllerchange', handler)
  }, [])

  return null
}
